import React, { useState, useRef, useEffect } from "react";
import { ReactComponent as DragHandleIcon } from "Assets/svg/conditionBlock/dragHandle.svg";
import { ReactComponent as PinIcon } from "Assets/svg/pin.svg";
import { CATEGORY_LABEL, CATEGORY_COLOR_CLASS } from "../utils/widgetConstants";
import WidgetCardSkeleton from "./WidgetCardSkeleton";

const DotMenu = ({ onPin, onRemove, isPinned }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = e => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  return (
    <div ref={ref} className="widgetCardDotMenuWrap">
      <button
        type="button"
        className="widgetCardDotMenuBtn"
        onClick={() => setOpen(o => !o)}
        title="Widget options"
      >
        <svg width="3" height="13" viewBox="0 0 3 13" fill="none">
          <circle cx="1.5" cy="1.5" r="1.5" fill="currentColor" />
          <circle cx="1.5" cy="6.5" r="1.5" fill="currentColor" />
          <circle cx="1.5" cy="11.5" r="1.5" fill="currentColor" />
        </svg>
      </button>
      {open && (
        <div className="widgetCardDotMenuDropdown">
          <button
            type="button"
            className="widgetCardDotMenuItem"
            onClick={() => { setOpen(false); onPin(); }}
          >
            {isPinned ? "Unpin" : "Pin to top"}
          </button>
          <button
            type="button"
            className="widgetCardDotMenuItem widgetCardDotMenuItemDanger"
            onClick={() => { setOpen(false); onRemove(); }}
          >
            Remove widget
          </button>
        </div>
      )}
    </div>
  );
};

const WidgetCard = ({
  title,
  subtitle,
  category,
  isLoading = false,
  isPinned = false,
  onRemove,
  onPin,
  onViewRecords,
  children
}) => {
  const colorClass = CATEGORY_COLOR_CLASS[category];
  return (
    <div className={`widgetCard${isPinned ? " widgetCardPinned" : ""}`}>
      {isPinned && <div className="widgetCardPinBar" />}
      <div className="widgetCardHeader">
        <div className="widgetCardTitleWrap">
          <div className="widgetCardTitle">
            {isPinned && <PinIcon className="widgetCardPinIcon" />}
            <span className="widgetCardTitleText">{title}</span>
            {category && (
              <span className={`widgetCardCategory${colorClass ? ` widgetCardCategory--${colorClass}` : ""}`}>
                {CATEGORY_LABEL[category] || category}
              </span>
            )}
          </div>
          {subtitle && <div className="widgetCardSubtitle">{subtitle}</div>}
        </div>
        <div className="widgetCardActions">
          {onViewRecords && (
            <button
              type="button"
              className="widgetCardViewRecordsBtn"
              onClick={onViewRecords}
              title="View Records"
            >
              <i className="material-icons">bar_chart</i>
            </button>
          )}
          <span className="widgetCardDragHandle" title="Drag to reorder">
            <DragHandleIcon />
          </span>
          <DotMenu isPinned={isPinned} onPin={onPin} onRemove={onRemove} />
        </div>
      </div>
      {isLoading ? <WidgetCardSkeleton /> : children}
    </div>
  );
};

export default WidgetCard;
